import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { MilestoneDto } from 'tdc-web-backend/milestones/schemas';

export type IntervalType = 'month' | 'halfyear' | 'year';

export type RevenueChartType = 'area' | 'bar';

export interface IRevenueChartProps {
  milestones: MilestoneDto[];
  type?: RevenueChartType;
  sx?: SxProps<Theme> | undefined;
}
export interface IGraphMilestone {
  id?: string;
  name?: string;
  date: Date | null;
  paidEur: number;
  unpaidEur: number;
  paidUsd: number;
  unpaidUsd: number;
  paidMilestonesEur: string[];
  paidMilestonesUsd: string[];
  unpaidMilestonesEur: string[];
  unpaidMilestonesUsd: string[];
}

export interface ILegendProps {
  displayLegend: boolean;
  setShowPaidEur: (value: boolean) => void;
  setShowPaidUsd: (value: boolean) => void;
  setShowUnpaidEur: (value: boolean) => void;
  setShowUnpaidUsd: (value: boolean) => void;
  showPaidEur: boolean;
  showPaidUsd: boolean;
  showUnpaidEur: boolean;
  showUnpaidUsd: boolean;
}

export interface IAreasProps {
  intervalType: IntervalType;
  showPaidEur: boolean;
  showPaidUsd: boolean;
  milestonesExistEur: boolean;
  milestonesExistUsd: boolean;
  allArePaidEur: boolean;
  allArePaidUsd: boolean;
  showUnpaidEur: boolean;
  showUnpaidUsd: boolean;
}

export const AreaDotRadius = 2.25;

export interface ICustomYAxisProps {
  highestValueField: string;
}

export interface ICustomXAxisProps {
  intervalType: IntervalType;
}

export interface ICustomAreaChartProps
  extends ILegendProps,
    IAreasProps,
    ICustomYAxisProps,
    ICustomXAxisProps {
  array: IGraphMilestone[];
}

export interface ICustomBarChartProps
  extends ILegendProps,
    IAreasProps,
    ICustomYAxisProps,
    ICustomXAxisProps {
  array: IGraphMilestone[];
}
